module.exports = __webpack_public_path__ + "img/A-Molds.d21f6259.png";